import React from 'react';
import {
  MENU_CODE_STUDIO_MONTHLY_REPORT,
  MENU_CODE_PERFORMANCE_OVERVIEW,
  MENU_CODE_GROSS_REVENUE_TRENDS,
  MENU_CODE_LIVE_TITLE,
  MENU_CODE_IN_DEVELOPMENT,
  MENU_CODE_GLOBALPEDIA,
  MENU_CODE_BENCHMARK,
  MENU_CODE_PIPELINE,
  MENU_CODE_OVERVIEW,
  MENU_CODE_PIPELINE_GR_ACTION_ITEMS,
  MENU_CODE_PROJECT_LIST,
  MENU_CODE_STUDIO_DASHBOARD,
  MENU_CODE_STUDIO_STUDIO_BUSINESS_METRICS,
  MENU_CODE_STUDIO_OVERALL,
  MENU_CODE_METRICS,
  MENU_CODE_MY_WORKSPACE,
  MENU_CODE_ADD_NEW_PRODUCT,
  MENU_CODE_DPS_WEEKLY_REPORT,
  MENU_CODE_GATE_REVIEW,
  MENU_CODE_NEWSLETTER,
  MENU_CODE_REPORT,
  MENU_CODE_REPORT_PUSH_MANAGEMENT,
  MENU_CODE_CHANGE_LOG,
  PERMISSION_APPLY_URL,
} from './const';

const GPOP_ACCESS_APPLICATION_FORM = (
  <a href={PERMISSION_APPLY_URL} target="_blank" rel="noreferrer">
    GPOP Access Application Form
  </a>
);

const CONTACT_FOR_GPOP_ACCESS_APPLICATION = <>please complete the {GPOP_ACCESS_APPLICATION_FORM}.</>;

const PIPELINE_CONTACT_TIPS = 'If you need further assistance, please contact jinglichen or judymao.';

const STUDIO_CONTACT_TIPS =
  'If you have any questions or if your request is urgent, please reach out to administrators kirashi or judymao.';

export const DESCRIPTION_A = (
  <>
    <p>You do not have the current system access permission.</p>
    <p>
      {CONTACT_FOR_GPOP_ACCESS_APPLICATION} {PIPELINE_CONTACT_TIPS}
    </p>
  </>
);

export const NO_PERMISSION_TIPS = (
  <>
    <p>
      Your current permission level does not allow you to view the information. To request access or upgrade your
      permissions,
    </p>
    <p>
      {CONTACT_FOR_GPOP_ACCESS_APPLICATION} {PIPELINE_CONTACT_TIPS}
    </p>
  </>
);

export const DESCRIPTION_B = (
  <>
    <p>
      Your current permission level does not allow you to access this page. To request access or upgrade your
      permissions,
    </p>
    <p>
      {CONTACT_FOR_GPOP_ACCESS_APPLICATION} {PIPELINE_CONTACT_TIPS}
    </p>
  </>
);

export const DESCRIPTION_C = (
  <>
    <p>This section is designed for post-investment management of IEGG majority studios.</p>
    <p>
      {/* eslint-disable-next-line react/no-unescaped-entities */}
      It provides a comprehensive view of a studio's general information, projects, people, financials, event calendar
      and other governance materials.
    </p>
    <p>
      To request access to <b>Studio Section</b> or to upgrade your current permissions, including access to sensitive
      data,
    </p>
    <p>{CONTACT_FOR_GPOP_ACCESS_APPLICATION}</p>
    <p>
      Your application will be processed within one week. You will receive a notification upon any changes to your
      access rights.
    </p>
    <p>{STUDIO_CONTACT_TIPS}</p>
  </>
);

export const DESCRIPTION_D = (
  <>
    <p>
      This section provides a dashboard view of IEGG studios and projects for leadership reporting, in particular, the
      performance analysis of live titles and the budget
      <br />& progress of titles currently in development.
    </p>
    <p>
      To request access to <b>Management Dashboard</b> or to upgrade your current permissions, including access to
      sensitive data,
    </p>
    <p>{CONTACT_FOR_GPOP_ACCESS_APPLICATION}</p>
    <p>
      Your application will be processed within one week. You will receive a notification upon any changes to your
      access rights.
    </p>
    <p>{STUDIO_CONTACT_TIPS}</p>
  </>
);

export const PAGE_NO_ACCESS_DESCRIPTION: Record<string, string | React.ReactElement> = {
  // Pipeline
  [MENU_CODE_PIPELINE]: DESCRIPTION_B,
  [MENU_CODE_OVERVIEW]: DESCRIPTION_B,
  [MENU_CODE_PROJECT_LIST]: DESCRIPTION_B,
  [MENU_CODE_PIPELINE_GR_ACTION_ITEMS]: DESCRIPTION_B,
  [MENU_CODE_DPS_WEEKLY_REPORT]: DESCRIPTION_B,
  [MENU_CODE_CHANGE_LOG]: DESCRIPTION_B,

  // Studio
  [MENU_CODE_STUDIO_DASHBOARD]: DESCRIPTION_C,
  [MENU_CODE_STUDIO_OVERALL]: DESCRIPTION_C,
  [MENU_CODE_STUDIO_STUDIO_BUSINESS_METRICS]: DESCRIPTION_C,

  // Monthly Report
  [MENU_CODE_STUDIO_MONTHLY_REPORT]: DESCRIPTION_D,
  [MENU_CODE_PERFORMANCE_OVERVIEW]: DESCRIPTION_D,
  [MENU_CODE_GROSS_REVENUE_TRENDS]: DESCRIPTION_D,
  [MENU_CODE_LIVE_TITLE]: DESCRIPTION_D,
  [MENU_CODE_IN_DEVELOPMENT]: DESCRIPTION_D,

  // Metrics
  [MENU_CODE_METRICS]: DESCRIPTION_B,

  // Workspace
  [MENU_CODE_MY_WORKSPACE]: DESCRIPTION_B,
  [MENU_CODE_ADD_NEW_PRODUCT]: DESCRIPTION_B,
  [MENU_CODE_GATE_REVIEW]: DESCRIPTION_B,

  [MENU_CODE_GLOBALPEDIA]: DESCRIPTION_A,
  [MENU_CODE_BENCHMARK]: DESCRIPTION_A,
  [MENU_CODE_NEWSLETTER]: DESCRIPTION_A,
  [MENU_CODE_REPORT]: DESCRIPTION_A,
  [MENU_CODE_REPORT_PUSH_MANAGEMENT]: DESCRIPTION_A,
};
